<script>
import { useUserStore } from '@/stores/UserStore'
import { computed } from '@vue/composition-api'
import { MODULES } from '@/constants/modules'
import NoModuleAccessMessage from '@/components/NoModuleAccessMessage.vue'
import AdvancedSettingsForm from '@/components/advancedSettings/AdvancedSettingsForm.vue'
import { featureEnabled, features } from '@/helpers/FeatureFlags'
import AppCard from '../components/app-card.vue'

export default {
  name: 'AdvancedSettings',
  components: { AppCard, AdvancedSettingsForm, NoModuleAccessMessage },
  setup() {
    const userStore = useUserStore()
    const isModuleEnabled = computed(
      () =>
        userStore.hasEnabledModule(MODULES.ADVANCED_SETTINGS) &&
        featureEnabled(features.advancedSettings)
    )

    userStore.hasEnabledAdvancedSetting('test')

    return {
      isModuleEnabled,
    }
  },
}
</script>

<template>
  <div>
    <div v-if="isModuleEnabled" class="content">
      <h2 class="mb-3">
        {{ $title }}
      </h2>
      <AdvancedSettingsForm />
    </div>
    <app-card v-else>
      <h2 class="mb-3">
        {{ $title }}
      </h2>
      <no-module-access-message />
    </app-card>
  </div>
</template>

<style scoped></style>
